type V2Response<T> =
  | {
      success: true
      data: T
    }
  | {
      success: false
      status: number
      errors: string[]
    }

export default async function v2Fetch<T>(path: string, options?: RequestInit): Promise<V2Response<T>> {
  let response: Response
  try {
    response = await fetch(`${process.env.EXPO_PUBLIC_API_BASE_URL}/api/v2${path}`, options)
  } catch (error) {
    return { success: false, status: 0, errors: [String(error)] }
  }

  if (!response.ok) {
    try {
      const text = await response.text()
      let data
      if (text) data = JSON.parse(text)
      return { success: false, status: response.status, errors: data?.errors ?? ['Unknown error'] }
    } catch (error) {
      console.error(error)
      return { success: false, status: response.status, errors: [String(error)] }
    }
  }

  try {
    const text = await response.text()
    let data
    if (text) data = JSON.parse(text)
    return { success: true, data }
  } catch (error) {
    console.error(error)
    return { success: false, status: response.status, errors: [String(error)] }
  }
}
